import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/elise1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/george3.png'
import srj4 from '../../images/srj4.png'
import srj5 from '../../images/srj5.png'
import srj6 from '../../images/srj6.png'
import srj7 from '../../images/george7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/george10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';



const George = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Local & B2B SEO <br/> Expansion for a Singapore <br/> Kitchen Cabinet Brand</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>30+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>Singapore</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>B2B</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Kitchen Cabinet and Counter <br/> Top Manufacturing</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>George owns a kitchen cabinet and countertop <br/> company in Singapore, offering Kitchen Cabinets, <br/> Countertops, Bathroom Vanities, and Kitchen & <br/> Bathroom accessories.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <p className='heading_description text-dark mb-0'>The business had been searching for a reliable partner that could handle SEO, broader marketing, and paid media across Google and Meta for nearly two years.</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Find a single agency accountable for end-to-end growth (SEO + Marketing + Google/Meta Ads).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Clarify the primary marketing channels that actually drive qualified demand in their category.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Increase the flow and quality of leads for both B2C (homeowners) and B2B (local vendors/partners).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Build a defensible brand presence while scaling SEO and paid campaigns sustainably.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>While the company enjoyed healthy demand in its immediate locality, George wanted to expand into three additional cities within Singapore and simultaneously establish steady B2B deal flow with local vendors, necessitating a long-term SEO and marketing partner who truly understands the business.</p>
                        
                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Identify the most effective marketing channels for the category.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Create a detailed brand-building plan to support expansion.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Deliver a strategy to increase high-quality lead flow across B2C and B2B.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Provide a step-by-step roadmap to scale SEO and paid marketing.</li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>
                    

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <p className='heading_description text-dark mb-0'>George wants a detailed marketing and SEO strategy that will help in local sales and acquiring B2B vendors.</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Fragmented location signals and inconsistent NAP across citations.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Thin, overlapping service/location pages risk keyword cannibalization.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Low review velocity and under-optimized Google Business Profile (GBP) assets.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Lead forms attract price-only enquiries with low purchase intent.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Media spend spreads too broadly with weak geo/intent controls.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Diagnosis & Audit</div>
                                                <p>Comprehensive technical audit (crawl depth, render-blocking resources, canonicals, sitemaps, pagination, duplicate templates) plus GBP/profile audits per target city.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content Strategy (Topical & Location Authority)</div>
                                                <p>Built a pillar-cluster model around core products (kitchen cabinets, countertops, bathroom vanities), mapped to three target cities. Added comparison and buyer-guide content (e.g., “quartz vs granite countertops”, “HDB kitchen renovation basics”), and intent-aligned CTAs.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI-SEO (AEO/GEO)</div>
                                                <p>Structured Q&A blocks, glossaries, and FAQ schema to surface concise answers in AI overviews and answer engines, improving visibility for “how-to” and “which-material” queries.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>On-Page Strategy</div>
                                                <p>Entity-rich, intent-segmented copy (research vs buyer) with modular CTAs (book showroom visit, free design consult, request B2B rate card).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Schema Enhancements</div>
                                                <p>Implemented LocalBusiness, Service, Product, FAQ, Breadcrumb, and Review (policy-compliant) schema; strengthened the internal-link graph to route discovery-stage traffic to city/service pages and RFQ paths.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>CRO & Lead Quality Uplift</div>
                                                <p>Redesigned forms with qualification gates (budget ranges, project stage, timeline), progressive profiling, and “book a showroom slot” scheduling. Deployed high-intent assets (material samplers, renovation checklists) behind minimal friction.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Local PR, Citations & Digital PR</div>
                                                <p>Curated Singapore-relevant citations and partnerships (interior design blogs, renovation forums), pursued unlinked brand mention reclamation, and byline contributions to build topical trust.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics, Governance & Ops</div>
                                                <p>GA4 + GSC dashboards aligned to funnel stages; CRM integration for pipeline attribution (first-touch SEO vs assisted); quarterly roadmap for content and location rollouts.</p>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<> Partner with us and get your custom AI SEO <br/> strategy for your business.</>} title2=''/>
                    
                    <section className="intro_about_section section_space max_900 project_outcome pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Stronger Local Presence</div>
                                                <p>Stronger local presence across three priority cities with dedicated location pages and enriched GBP profiles.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Good Quality Leads</div>
                                                <p>Noticeable uplift in qualified enquiries (design consult bookings generic price requests).</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Helped in Acquiring B2B Vendors</div>
                                                <p>Clear B2B path created (vendor/partner page + rate card + appointment flow) leading to consistent partner conversations.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Optimized Campaigns</div>
                                                <p>Measurable improvements in on-site engagement and lead qualification signals (form completeness, budget disclosure, project stage notes).</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default George;
